import axios from 'axios';
import EventDispatcher from './lib/event-dispatcher';
import { createApp, h } from 'vue';
import AppComments from './apps/AppComments.vue';
import AppRelatedTasks from './apps/AppRelatedTasks.vue';
import AppAdminArchiveButton from './apps/AppAdminArchiveButton.vue';
import FilesWidget from './apps/FilesWidget.vue';
import ProfilePhoneNumber from './apps/ProfilePhoneNumber.vue';
import ProjectNotebook from './apps/ProjectNote.vue';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Init global scope Vue instance used as event dispatcher
 * @type {import('vue').App<Element>}
 */

window.$eventDispatcher = new EventDispatcher();

document.addEventListener('DOMContentLoaded', () => {
	/**
	 * Comments App
	 */
	const appComments = document.getElementById('app-comments');

	if (appComments) {
		createApp({
			render: () => h(AppComments)
		}).mount(appComments);
	}

	/**
	 * Related Tasks App
	 */
	const appRelatedTasks = document.getElementById('app-related-tasks');

	if (appRelatedTasks) {
		const dataSet = { ...appRelatedTasks.dataset };

		createApp({
			render: () => h(AppRelatedTasks),
			created() {
				this.dataSet = dataSet;
			}
		}).mount(appRelatedTasks);
	}

	/**
	 * Archive Button App
	 */
	const appAdminArchiveButton = document.getElementById('app-admin-archive-button');

	if (appAdminArchiveButton) {
		createApp({
			render: () => h(AppAdminArchiveButton)
		}).mount(appAdminArchiveButton);
	}

	const filesWidget = document.querySelector('.sidebar-box.files');
	if (filesWidget) {
		createApp({
			render: () => h(FilesWidget)
		}).mount(filesWidget);
	}

	const profilePhoneNumber = $('#profile-phone-number-input-row');
	if (profilePhoneNumber) {
		const props = profilePhoneNumber.data('props');

		createApp({
			render: () => h(ProfilePhoneNumber, { ...props })
		}).mount(profilePhoneNumber[0]);
	}

	const $projectNotebook = $('.project-notebook');
	if ($projectNotebook.length) {
		createApp({
			render: () => h(ProjectNotebook)
		}).mount($projectNotebook[0]);
	}

});